import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
  InputSignal,
  ViewEncapsulation,
} from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import {
  faChevronDown,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'lyceo-accordion-item',
  imports: [FontAwesomeModule],
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AccordionItemComponent extends CdkAccordionItem {
  public showChevron: InputSignal<boolean | null> = input<boolean | null>(true);

  protected readonly faChevronDown: IconDefinition = faChevronDown;

  @HostBinding('class.lyceo-accordion-item')
  public get lyceoExerciseCard(): boolean {
    return true;
  }

  @HostBinding('class.is-expanded')
  public get isExpanded(): boolean {
    return this.expanded;
  }
}
